module.exports = __webpack_public_path__ + "img/close_color.8d00f1f5.svg";